import { AxiosResponse } from 'axios'
import { AgencyAllowIpInfo } from 'src/types/agencyAllowIp'

import axios from '../../axios'

export const fetchAgencyIpList = async (
  agencyCode: string | null,
  page: number
): Promise<AxiosResponse> => {
  const params = { agencyCode, page }
  const response = await axios
    .get<{ data: AgencyAllowIpInfo }>('/api/agency-ips', { params })
    .catch((error) => {
      return error.response
    })

  return response
}
